import {Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {flowsReportApi} from '@/features/reports/services';
import BaseReport from '@/features/reports/components/flows/baseReport';
import {DateGrouping} from '@/features/reports/models';

export default abstract class BaseFlowReport extends BaseReport {
	@Getter public selectedFlowId!: string;

	@Watch('selectedFlowId')
	public async onFlowChange(newFlowId: string, previous: string) {
		if (newFlowId && newFlowId === previous) {
			return;
		}
		await this.renderReportData();
	}

	public isReportCriterionValid(): boolean {
		return !!this.selectedDateOption && !!this.selectedFlowId;
	}

	public loadReportData() {
		const filterRange = this.selectedDateOption.getDateRange();

		return flowsReportApi.get(this.currentWorkspace.id, {
			type: this.reportId,
			flowId: this.getFlowIdForRequest(),
			startDate: filterRange.start,
			endDate: filterRange.end,
			grouping: this.dataPointGrouping()
		});
	}

	public dataPointGrouping(): DateGrouping {
		return this.selectedDateOption.group;
	}

	public getFlowIdForRequest(): string {
		return this.selectedFlowId;
	}
}
